import React, { useState } from 'react';
import axios from 'axios';
import "./HomeSection.css";
import YourPerfectHome from '../components/findurperfecthome';
import WhatAreYou from "../components/Whatareulookingfor";
import AboutUs from "../components/Aboutus";
import UniqueListing from "../components/Uniquelisting";
import ContactSection from "../components/contacthomesection"
const HomeSection = () => {
      const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        message: "",
      });
    
      const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          const res = await axios.post(
            "https://manirajbuilder.com/contact.php",
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          alert(res.data.message || "Message sent successfully!");
          setFormData({ name: "", phone: "", email: "", message: "" }); // Reset form
        } catch (err) {
          console.error(err);
          alert("Something went wrong. Please try again later.");
        }
      };
    
    return (<>
        <div className="home-section">
            <div className="background-image">
               

                <div className="foryourdream" style={{ fontFamily: "'Work Sans', 'sans-serif'",  }}>
                    Find Your <span style={{ color: "rgba(255, 140, 0, 0.8)" }}>Dream Home</span> Today

                </div>


            
            </div>

            <div className="form-section">//
      <h2>Get in Touch</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            id="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}

 

            required
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            id="phone"
            placeholder="Enter your contact number"
                 value={formData.phone}
                onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            id="email"
            placeholder="Enter your email"
            value={formData.email}
                onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <textarea
           
            rows="4"
            placeholder="Enter your message"
             id="message"
                value={formData.message}
                onChange={handleChange}
            required
          ></textarea>
        </div>
        <button type="submit">Submit</button>
      </form>

    
    </div>
        </div>


        {/* Find Your Perfect Home Section */}
        <YourPerfectHome />
        <AboutUs />
        <UniqueListing />

        <WhatAreYou />
        <ContactSection />
    </>
    );
};

export default HomeSection;
